import { ChangeEvent, FunctionComponent } from 'react';
import styles from './DropDownHeader.module.scss';
import clsx from 'clsx';
import Avatar from './Avatar';

interface DropDownHeaderProps {
    selectedAvatar: string | null;
    selectedStaffName: string | null;
    className?: string;
    onChange?: (search: string) => void;
}

export const DropDownHeader: FunctionComponent<DropDownHeaderProps> = props => {
    const changeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        props.onChange?.(event.target.value);
    };

    return (
        <div className={clsx(styles.container, props.className)}>
            <Avatar
                imageUrl={props.selectedAvatar}
                className={styles.avatar}
            />
            <input
                className={styles.input}
                type="text"
                placeholder={props.selectedStaffName || 'Name or email'}
                onClick={event => event.stopPropagation()}
                autoFocus={true}
                onChange={changeHandler}
            />
        </div>
    );
};

export default DropDownHeader;
